import { all } from 'redux-saga/effects'
import { watchCurrencyActions } from './sagas-currency'
import { watchProviderActions } from './sagas-provider'
import { watchTransactionActions } from './sagas-transaction'
import { watchWalletActions } from './sagas-wallet'

export default function* rootSaga() {
  yield all([
    watchCurrencyActions(),
    watchProviderActions(),
    watchWalletActions(),
    watchTransactionActions()
  ])
}
